import { useOlapScoresParams } from "src/context/OlapScores/useOlapScoresParams";
import { ScoreService } from "src/services/ScoreService";
import { useEffect } from "react";
import { useEntityScores } from "src/context/Scores/useEntityScores";

export const useQuestionnaireUpdateScoresParams = () => {
    const { lastSelectedVariation } = useEntityScores();

    const scoresParams = useOlapScoresParams({
        scores: {
            dimensions: [
                [["headings"], ["subheadings"], ["properties"], ["multivalues"], ["subproperties"]],
                [["ssq_versions"], ["headings"]],
            ],
            ids: ScoreService.getScoreIdsByLastSelectedVariation(lastSelectedVariation),
            variations: ScoreService.getVariationByLastSelectedVariation(lastSelectedVariation),
        },
    });

    useEffect(() => {
        scoresParams.state.setQuery({
            scores: {
                ...scoresParams.query.scores,
                ids: ScoreService.getScoreIdsByLastSelectedVariation(lastSelectedVariation),
                variations: ScoreService.getVariationByLastSelectedVariation(lastSelectedVariation),
            },
        });
    }, [lastSelectedVariation]);

    return {
        scoresParams,
    };
};
